const SET_PODCAST = 'global/podcast/SET_PODCAST';

export default {
  SET_PODCAST,
};
